import { combineReducers, Reducer } from 'redux';

import * as types from './meeting-boards.types';
import * as constants from './meeting-boards.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IMeetingBoardsPageState = {
  meetingBoards: {},
};

const meetingBoardsReducer: Reducer<
  types.IMeetingBoardsPageState['meetingBoards'],
  types.IStoreMeetingBoards | types.IClearMeetingBoards
> = (state = initialState.meetingBoards, action) => {
  if (isActionOfType<types.IStoreMeetingBoards>(action, constants.STORE_MEETING_BOARDS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingBoards>(action, constants.CLEAR_MEETING_BOARDS)) {
    return initialState.meetingBoards;
  }
  return state;
};

export const meetingBoardsPageReducer: Reducer<
  types.IMeetingBoardsPageState,
  types.IMeetingBoardsPageAction
> = combineReducers({
  meetingBoards: meetingBoardsReducer,
});
